import React from "react";
import { Link } from "react-router-dom";
import {Phone, Mail, MapPin} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="text-xl font-bold mb-4">
              <span className="text-white">DRAG CAR</span>
              <span className="text-[#DC0000]"> INSURANCE</span>
            </div>
            <p className="text-gray-400 text-sm">
              Specialized insurance coverage for drag racing enthusiasts and
              semi-pro racers.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/coverage"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Coverage Options
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Get a Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Coverage Types */}
          <div>
            <h3 className="text-white font-semibold mb-4">Coverage Types</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Drag Racers Insurance</li>
              <li>Liability Coverage</li>
              <li>Physical Damage</li>
              <li>Off-Track Storage</li>
              <li>Trailer Coverage</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>1-800-DRAG-CAR</span>
              </li>
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>info@dragcarinsurance.com</span>
              </li>
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Available Nationwide</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Drag Car Insurance. All rights
            reserved. | Specialized drag race car insurance coverage.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
